export enum Status {
    /** Status 0 (bestellt) */
    ORDERED = 0,
    /** Status 1 (aktiv) */
    ACTIVE = 1,
    /** Status 2 (abgelehnt) */
    DENIED = 2,
    /** Status 3 (gesperrt) */
    LOCKED = 3,
    /** Status 4 (Sperre angefordert) */
    LOCK_REQUESTED = 4,
    /** Status 5 (Deaktivierung angefordert) */
    DEACTIVATION_REQUESTED = 5,
    /** Status 6 (inaktiv) */
    INACTIVE = 6,
    /** Status 7 (Kündigung vorgemerkt) */
    TERMINATION_BOOKMARKED = 7,
    /** Status 8 (Entsperrung angefordert) */
    UNLOCKING_REQUESTED = 8,
    /** Status 9 (gekündigt) */
    TERMINATED = 9,
    /** Status 10 (Aktivierung angefordert) */
    ACTIVATION_REQUESTED = 10,
    /** Status 11 (versandt) */
    SENT = 11,
    /** Status 12 (Storno angefordert) */
    CANCELLATION_REQUESTED = 12,
    /** Status 13 (storniert) */
    CANCELLED = 13,
    /** Status 14 (nicht verfügbar) */
    NOT_AVAILABLE = 14,
    /** Status 15 (defekt) */
    DEFECTIVE = 15,
    /** Status 16 (exportiert) */
    EXPORTED = 16,
    /** Status 17 (beendet) */
    COMPLETED = 17,
    /** Status 19 (in Migration) */
    MIGRATING = 19,
    /** Status 99 (als gelöscht markiert) */
    MARKED_AS_DELETED = 99,

    /** Pseudo status for MaRe Migration */
    MARE_MIGRATION = -1,
}
